import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useResponsive } from "@sundae/react-hooks";
import cx from "classnames";
import { useMemo } from "react";
import { toolkitCx } from "../../../constants";
import { Cross1Icon, HamburgerMenuIcon } from "../../../icons";
import Text from "../../atoms/Text";
const HeaderBurger = ({ closeOffCanvasLabel, openOffCanvasLabel, offCanvasState, }) => {
    const responsive = useResponsive();
    const isLargeScreen = useMemo(() => responsive.lg || responsive.xl || responsive.xxl, [responsive.lg, responsive.xl, responsive.xxl]);
    if (isLargeScreen) {
        return null;
    }
    return (_jsxs("button", { className: cx("flex items-center gap-2", "lg:hidden", toolkitCx.layout.text.default), onClick: () => offCanvasState.setIsOpen(!offCanvasState.isOpen), children: [closeOffCanvasLabel && openOffCanvasLabel && (_jsx(Text, { tag: "span", size: "sm", children: offCanvasState.isOpen ? closeOffCanvasLabel : openOffCanvasLabel })), offCanvasState.isOpen ? _jsx(Cross1Icon, {}) : _jsx(HamburgerMenuIcon, {})] }));
};
export default HeaderBurger;
//# sourceMappingURL=HeaderBurger.js.map